module.exports = __webpack_public_path__ + "img/water-level-new2.7f98ea13.gif";